var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 389.91 207.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00b4e4;}.cls-2{fill:#fff;}.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.87px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.84,
    y: 114.28,
    width: 51.05,
    height: 27.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 0.94,
    y: 106.32,
    width: 68.38,
    height: 43.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 22.66,
    y: 131.14,
    width: 46.66,
    height: 34.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.42,
    y: 158.31,
    width: 26.9,
    height: 24.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.2,
    y1: 183.6,
    x2: 56.2,
    y2: 206.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 121.85,
    y: 99.76,
    width: 39.34,
    height: 59.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 127.71,
    y: 104.91,
    width: 27.63,
    height: 37.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 141.52,
    cy: 150.34,
    r: 4.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 206.16,
    y: 99.76,
    width: 44.03,
    height: 59.95,
    transform: "translate(98.43 357.91) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 205.9,
    y: 110.97,
    width: 32.43,
    height: 37.54,
    transform: "translate(92.38 351.85) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 248.78,
    cy: 129.74,
    r: 4.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 14.6,
    y: 16.86,
    width: 44.03,
    height: 59.95,
    transform: "translate(-10.23 83.45) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.08,
    y: 22.34,
    width: 32.43,
    height: 49,
    transform: "translate(-10.55 83.13) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.08,
    y: 34.51,
    width: 32.43,
    height: 49,
    transform: "translate(-22.73 95.3) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 66.51,
    cy: 25.29,
    r: 24.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 333.24,
    y: 121.74,
    width: 27.63,
    height: 37.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 299.52,
    y: 112.37,
    width: 27.63,
    height: 37.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 362.28,
    y: 103,
    width: 27.63,
    height: 37.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 308.42,
    y: 87.55,
    width: 27.63,
    height: 37.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 332.77,
    y: 73.5,
    width: 27.63,
    height: 37.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 348.23,
    y: 103.94,
    width: 27.63,
    height: 37.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 314.27,
    y: 103.94,
    width: 27.63,
    height: 37.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 337.69,
    y: 127.36,
    width: 27.63,
    height: 37.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 205.92,
    y: 20.6,
    width: 44.03,
    height: 59.95,
    transform: "translate(177.36 278.51) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 205.67,
    y: 31.8,
    width: 32.43,
    height: 37.54,
    transform: "translate(171.3 272.45) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 248.54,
    cy: 50.57,
    r: 4.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 221.07,
    cy: 50.43,
    r: 11.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m219.08,45.9v9.13l6.03-4.63s-5.91-4.51-6.03-4.51Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.508b4b594d85343c50037b060baa8565.svg";
export { ForwardRef as ReactComponent };